/**
 * @module app.um
 */

import * as UM from 'app/um/models/essette-api';
import { DateRange } from 'app/um/models/essette-api';
import { DateComparison } from 'app/shared/lib/date-utilities';

export function authIsReadOnly(auth: UM.Auth, userId: string, canEditAuths: boolean, canEditClosedAuths?: boolean): boolean {
    const assignedToUserId = !!auth.assignedTo?.id && auth.assignedTo.id === userId;
    const userCanEditAuth = assignedToUserId || canEditAuths;
    return auth.isClosed ? !canEditClosedAuths : !userCanEditAuth;
}


export function checkForOverlappingDates(detailA: UM.AuthMedication | UM.AuthService, detailB: UM.AuthMedication | UM.AuthService): boolean {
    return DateComparison.checkForOverlappingDates(detailA.authorizedDate, detailA.expirationDate, detailB.authorizedDate, detailB.expirationDate);
}

export function checkForContainingDates(detailA: DateRange | undefined, detailB: UM.AuthMedication | UM.AuthService | undefined): boolean {
    if(detailB?.status?.flag?.allowNullDateOfService) {
        return DateComparison.checkForContainingDates(
            detailA?.start,
            detailA?.end,
            detailB?.authorizedDate || detailA?.start,
            detailB?.expirationDate || detailA?.end);
    } else {
        return DateComparison.checkForContainingDates(
            detailA?.start,
            detailA?.end,
            detailB?.authorizedDate,
            detailB?.expirationDate);
    }
}

export function getProviderContractStatus(auth: UM.Auth, provider: UM.AuthProviderModel | null | undefined): void {
    if(!provider) return;

    if(provider && provider.detail) {
        provider.detail.isContracted = auth.providers?.find(p => p.id === provider!.id)?.detail?.isContracted;
    }
}
